import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SessionService } from '@monsido/core/session/session.service';

@Injectable({
    providedIn: 'root',
})
export class IntercomService {
    constructor (
        @Inject(DOCUMENT) private document: Document,
        private sessionService: SessionService,
    ) {}

    addMsg (msg: string): void {
        if (typeof (window as any).Intercom === 'function') {
            (window as any).Intercom('showNewMessage', msg);
        }
    }

    boot (obj: any): void {
        if (typeof (window as any).Intercom === 'function') {
            (window as any).Intercom('boot', obj);
        }
    }

    shutdown (): void {
        if (this.hasIntercom()) {
            (window as any).Intercom('shutdown');
        }
    }

    update (obj?: any): void {
        if (typeof (window as any).Intercom === 'function') {
            (window as any).Intercom('update', obj);
        }
    }

    onShow (cb: () => void): void {
        if (this.hasIntercom()) {
            (window as any).Intercom('onShow', cb);
        }
    }

    onHide (cb: () => void): void {
        if (this.hasIntercom()) {
            (window as any).Intercom('onHide', cb);
        }
    }

    onUnreadCountChange (cb: (unreadCount: number) => void): void {
        if (this.hasIntercom()) {
            (window as any).Intercom('onUnreadCountChange', cb);
        }
    }

    trackEvent (event: string, metadata?: any): void {
        if (this.hasIntercom()) {
            (window as any).Intercom('trackEvent', event, metadata);
        }
    }

    private hasIntercom (): boolean {
        return typeof (window as any).Intercom === 'function' && this.sessionService.getChatSystem() === 'intercom';
    }
}
